
import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import ScreenCard from "@/components/screens/ScreenCard";
import { Screen } from "@/models/screen";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface DashboardScreensProps {
  screens: Screen[];
  isLoading?: boolean;
}

const DashboardScreens: React.FC<DashboardScreensProps> = ({ screens, isLoading = false }) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  
  // Add this console.log to debug what screens are being received
  console.log("DashboardScreens - received screens:", screens);
  
  // Si no hay pantallas disponibles pero estamos cargando, mostramos mensaje de carga
  if (isLoading) {
    return (
      <div>
        <h2 className="text-2xl font-bold mb-4">Pantallas</h2>
        <Card className="p-6">
          <div className="flex flex-col items-center justify-center py-4">
            <p>Cargando pantallas...</p>
          </div>
        </Card>
      </div>
    );
  }

  // Si no hay pantallas después de cargar, mostramos mensaje
  if (screens.length === 0) {
    return (
      <div>
        <h2 className="text-2xl font-bold mb-4">Pantallas</h2>
        <Card className="p-6">
          <div className="flex flex-col items-center justify-center py-4">
            <p>No hay pantallas disponibles</p>
          </div>
        </Card>
      </div>
    );
  }

  // Filtramos las pantallas según el término de búsqueda
  const filteredScreens = searchTerm 
    ? screens.filter(screen => 
        screen.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        screen.location.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : screens;

  // Si tenemos pantallas, las mostramos sin filtrar por rol
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Pantallas</h2>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input 
            placeholder="Buscar pantalla..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-9"
          />
        </div>
      </div>
      
      {filteredScreens.length === 0 ? (
        <Card className="p-6">
          <div className="flex flex-col items-center justify-center py-4">
            <p>No se encontraron pantallas con ese criterio</p>
          </div>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {filteredScreens.map((screen) => (
            <ScreenCard key={screen.id} screen={screen} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardScreens;
